// Global init
// require('./lnw/global');
//
// export * from './lnw/index'

require('@lnw/base');